import { useContext } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { NotificationContext } from "../context/notification-context";
import { NotificationManager } from "react-notifications";
import { LoaderContext } from "../context/loader-context";
import { ErrorContext } from "../context/error-context";
import { API_URL } from "../config/config";
import authHook from "./auth-hook";

export default () => {
  const { logout } = authHook();
  const { incrementRequests, decrementRequests } = useContext(LoaderContext);
  const { ErrorNotification, SuccessNofication } = useContext(NotificationContext);
  const { setError } = useContext(ErrorContext);
  useHistory();
  const fetchMssqlApi = (
    path,
    {
      method = "GET",
      data = null,
      hideNotification,
      params = null,
      showLoader = true,
      responseType,
      isErrorAcceptable = false,
      signal = null,
    } = {},
    onSuccess = () => {},
    onError = (err) => {
      if (!isErrorAcceptable) {
        NotificationManager.error(
          "Wystąpił błąd, skontaktuj się ze Wsparciem Technicznym: serwis@retail24.pl"
        );
      }
    },
    offlineFunc = () => {}
  ) => {
    if (!navigator.onLine) {
      offlineFunc(onSuccess, onError);

      return {
        request: Promise.resolve(null),
        cancel: () => {},
      };
    }

    const controller = new AbortController();
    const requestSignal = controller.signal;

    const cancelTokenSource = axios.CancelToken
      ? axios.CancelToken.source()
      : null;

    let cancelTokenCanceled = false;
    let removeExternalAbortListener = null;
    let loaderRequestId = null;

    const cancelRequest = (source = "request canceled") => {
      if (!requestSignal.aborted) {
        controller.abort(source);
      }

      if (cancelTokenSource && !cancelTokenCanceled) {
        cancelTokenCanceled = true;
        cancelTokenSource.cancel(source);
      }
    };

    if (signal) {
      if (signal.aborted) {
        cancelRequest("external signal already aborted");
      } else {
        const onExternalAbort = () => {
          cancelRequest("external signal aborted");
        };

        signal.addEventListener("abort", onExternalAbort, { once: true });

        removeExternalAbortListener = () => {
          signal.removeEventListener("abort", onExternalAbort);
        };
      }
    }

    if (showLoader) {
      loaderRequestId = incrementRequests(() => cancelRequest("loader-x-click"), `${method} /api/${path}`);
    }

    const request = axios({
      method,
      url: `${API_URL}/api/${path}`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      data,
      params,
      responseType,
      signal: requestSignal,
      ...(cancelTokenSource
        ? {
            cancelToken: cancelTokenSource.token,
          }
        : {}),
    })
      .then((res) => {
        if (res.status > 299) {
          throw new Error();
        }

        onSuccess(res.data);

        if (method !== "GET" && !hideNotification) {
          SuccessNofication(res.data.message);
        }

        return res.data;
      })
      .catch((err) => {
        const isCanceled =
          err?.code === "ERR_CANCELED" ||
          err?.name === "CanceledError" ||
          axios.isCancel?.(err) ||
          requestSignal.aborted ||
          cancelTokenCanceled;

        if (isCanceled) {
          return null;
        }

        if (err.response?.status === 401) {
          logout().then(() => window.location.reload());
          return null;
        }

        if (err.response?.data?.message === "jwt malformed") {
          window.location.reload();
          return null;
        }

        if (onError) {
          return onError(err);
        }

        if (method === "GET") {
          setError(err.response?.data || "Failed to fetch data.");
        } else {
          ErrorNotification(err.response?.data || err.toString());
        }

        return null;
      })
      .finally(() => {
        if (removeExternalAbortListener) {
          removeExternalAbortListener();
        }

        if (showLoader && loaderRequestId) {
          decrementRequests(loaderRequestId);
        }
      });

    return {
      request,
      cancel: () => {
        cancelRequest("manual-cancel");
      },
    };
  };

  return { fetchMssqlApi };
};